type NotifData = Record<string, string>;

const NOTIF_ROUTE_MAP: Record<string, (d: NotifData) => { name: string; params?: Record<string, string> }> = {
  create_order:        d => ({ name: 'order-detail',    params: { id: d.order_id ?? d.id } }),
  order_cancel:        d => ({ name: 'order-detail',    params: { id: d.order_id ?? d.id } }),
  order_complete:      d => ({ name: 'order-detail',    params: { id: d.order_id ?? d.id } }),
  order_with_customer: d => ({ name: 'order-detail',    params: { id: d.order_id ?? d.id } }),
  payment_received:    d => ({ name: 'order-detail',    params: { id: d.order_id ?? d.id } }),
  payment_refunded:    d => ({ name: 'order-detail',    params: { id: d.order_id ?? d.id } }),
};

export function resolveNotifRoute(data: NotifData) {
  const key = data.event_key ?? data.event ?? data.type ?? '';
  const resolver = NOTIF_ROUTE_MAP[key];
  return resolver ? resolver(data) : null;
}
